import moment from "moment";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import jobLogo from "../../assets/joblogo.jpg";
import location from "../../assets/location.svg";
import Employees from "../../assets/Employees.svg";

const JobCard = ({ data }) => {
  console.log("comapnySearch", data);
  const navigate = useNavigate();
  return (
    <div
      className="d-flex  p-3 flex-column shadow bg-white  mb-3 jobdet"
      onClick={() => navigate(`/jobSeeker/company/companyprofile/${data._id}`)}
    >
      <div className="d-flex gap-3">
        <img
          src={data?.companyLogo || jobLogo}
          width="120px"
          height="120px"
          style={{ border: "1px solid rgb(0,0,0,0.2)", padding: "2px" }}
          alt={data?.title}
        />
        <div className="d-flex flex-column">
          <div>
            <h6 className="text-dark mb-0">{data?.companyName}</h6>
          </div>
          <p className="mt-0" style={{ fontSize: "12px" }}>
            {data?.companyTagline}
          </p>
          <div className="d-flex gap-4 loc-s">
            <div className="d-flex">
              <img
                src={location}
                width="20px"
                height="20px"
                alt={data?.company}
              />
              <h6 className="text-info">{data?.location || "No Location"}</h6>
            </div>
          </div>
          <div className="d-flex gap-4 loc-s">
            <div className="d-flex">
              <img
                src={Employees}
                width="20px"
                height="20px"
                alt={data?.company}
              />
              <h6 className="text-info">{data.employees}</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default withTranslation()(JobCard);
